
export const testTypes = {
  FUNCTIONAL_TEST: 'functional_test',
  LOAD_TEST: 'load_test'
};

export const inputTypes = {
  INPUT_LIST: 'INPUT_LIST',
  NUMERIC_INPUT: 'NUMERIC_INPUT',
  NUMERIC_WITH_SWITCH: 'NUMERIC_WITH_SWITCH',
  SWITCHER: 'SWITCHER',
  SWITCHER_TWO_SIDES: 'SWITCHER_TWO_SIDES',
  TEXT_FIELD: 'TEXT_FIELD',
  RADIO: 'RADIO',
  MULTI_SELECT: 'MULTI_SELECT'
};
